// ============================================================
// Network Status Store
// ============================================================
// Manages global online/offline state, auto-reconnection detection,
// and ensures no destructive API calls are attempted while offline.

import { create } from 'zustand';

export const useNetworkStore = create((set, get) => ({
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  wasOffline: false,
  reconnecting: false,

  setOffline: (offline) => {
    const prev = get().isOffline;
    if (prev !== offline) {
      set({ 
        isOffline: offline,
        wasOffline: prev && !offline ? true : get().wasOffline,
        reconnecting: false
      });
    }
  },

  setReconnecting: (reconnecting) => set({ reconnecting }),

  resetWasOffline: () => set({ wasOffline: false }),
}));

export default useNetworkStore;
